import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FormikFormTomadasAcoes } from "../TomadasAcoes";
import { InputTextarea } from 'primereact/inputtextarea';
import { confirmDialog } from 'primereact/confirmdialog';
import GAS from "../../../GAS";

const HEARTBEAT_INTERVAL_MS = 15000; // Renova a cada 15s (TTL backend = 45s)

const ModalEditarTomadasAcoes = ({ visible, setDialogEditarTomadasAcoes, setEditTopico, setPainel, metamodeloAvaliativo, painel, usuario, editTopico, showMessage, idSessao }) => {
    
    const [acoesAntigas, setAcoesAntigas] = useState([]);
    const [acoesAtualizadas, setAcoesAtualizadas] = useState([]);
    const gasObj = GAS.getInstance();
    const isEdicao = editTopico?.editIndex !== undefined;

    useEffect(() => {
        setAcoesAntigas(JSON.parse(JSON.stringify(editTopico.acoes)));
        setAcoesAtualizadas(JSON.parse(JSON.stringify(editTopico.acoes)));
    }, [editTopico.acoes])

    // Heartbeat de renovação do lock
    useEffect(() => {
        if (!isEdicao) return; // Criação de novo tópico não tem lock a renovar

        const nomeTopico = editTopico?.topico;

        const heartbeat = setInterval(async () => {
            try {
                const res = await gasObj.request(
                    'MCPAPainelApropriador.instance.SERVICE.GETLockTopico',
                    painel.proprietario,
                    nomeTopico,
                    usuario.email,
                    idSessao
                );
                if (!res.response?.sucesso) {
                    showMessage('warn', 'Edição interrompida',
                        `Sua sessão expirou e ${res.response?.bloqueadoPor || 'outro usuário'} assumiu a edição deste tópico. Você não conseguirá salvar.`);
                }
            } catch (error) {
                console.error('Erro ao renovar lock das ações:', error);
            }
        }, HEARTBEAT_INTERVAL_MS);

        return () => clearInterval(heartbeat);
    }, [isEdicao]);

    const fecharELiberarLock = async () => {
        const nomeTopico = editTopico?.topico;

        setDialogEditarTomadasAcoes(false);
        setEditTopico(null);

        try {
            if (isEdicao) {
                await gasObj.request(
                    'MCPAPainelApropriador.instance.SERVICE.DELETELockTopico', 
                    painel.proprietario,
                    nomeTopico,
                    usuario.email,
                    idSessao
                );
            }
        } catch (error) {
            console.error("Erro ao liberar lock das ações:", error);
        }
    };

    const handleSalvarTopico = async (topico) => {
        topico.revisao = {
            data: new Date().toJSON(),
            usuario: usuario.email
        };

        topico.acoes.forEach(acao => {
            if (!acao.revisao) {
                acao.revisao = {
                    data: new Date().toJSON(),
                    usuario: usuario.email
                }
            }
        });

        const { editIndex, ...topicoParaSalvar } = topico;

        setDialogEditarTomadasAcoes(false);
        painel.topicos[editIndex] = topicoParaSalvar;
        setPainel({ ...painel });
        setEditTopico(null);

        try {
            const resposta = await gasObj.request(
                'MCPAPainelApropriador.instance.SERVICE.POSTSalvarTopico', 
                painel.proprietario, 
                topicoParaSalvar,
                undefined, 
                idSessao
            );

            if (resposta.response?.sucesso === false && resposta.response?.motivo === 'LOCK_PERDIDO') {
                showMessage('error', 'Conflito de edição',
                    `Este tópico foi editado por ${resposta.response.bloqueadoPor} enquanto você tinha as ações abertas. Recarregando a página...`);
                setTimeout(() => window.location.reload(), 2500); // dá tempo do toast aparecer antes do reload
                return;
            }

            showMessage('success', 'Salvo', 'Ações de melhoria salvas com sucesso.');
        } catch (error) {
            console.error("Erro ao salvar ações:", error);
            showMessage('error', 'Erro', 'Falha ao sincronizar as ações com o servidor.');
        }
    }

    const footer = (
        <div className="p-d-flex p-jc-between p-mt-3">
            <Button className="p-button-danger" label="CANCELAR" icon="pi pi-times" onClick={() => {
                confirmarSaida();
            }} />
            <Button type="submit" form="edit-tomadasacoes" label="SALVAR" icon="pi pi-check" tooltip="Salva alterações nas ações de melhoria" />
        </div>
    );

    const DROPDOWN_OPTIONS_AVALIACAO = metamodeloAvaliativo.escalaAvaliativa.map((itemEscalaAvaliativaEntry, index) => {
        return {
            label: itemEscalaAvaliativaEntry.valorQualitativo, value: index
        }
    });

    const headerTomadasAcoes = (
        <div className="p-field p-fluid">
            <label className="p-d-block">TÓPICO</label>
            <div className="p-mb-1">{/* Renderização do sentimento */}</div>
            <div><InputTextarea autoResize disabled value={editTopico.topico} /></div>
        </div>
    );

    const receberAcoesAtualizadas = (acoes) => {
        setAcoesAtualizadas(acoes);
    }

    const houveAlteracaoAcoes = () => {
        if (!acoesAntigas || !acoesAtualizadas) return false;
        if (acoesAntigas.length !== acoesAtualizadas.length) return true;

        return !acoesAntigas.every(acaoAntiga => {
            const acaoCorrespondente = acoesAtualizadas.find(acaoAtual => acaoAtual.acao === acaoAntiga.acao);
            if (!acaoCorrespondente) return false;

            const mesmosComprovacoes = JSON.stringify(acaoAntiga.comprovacoes) === JSON.stringify(acaoCorrespondente.comprovacoes);
            const mesmosImpedimentos = JSON.stringify(acaoAntiga.impedimentos) === JSON.stringify(acaoCorrespondente.impedimentos);
            const mesmaAvaliacao = acaoAntiga.avaliacao === acaoCorrespondente.avaliacao;

            return mesmosComprovacoes && mesmosImpedimentos && mesmaAvaliacao;
        }) 
    }

    const confirmarSaida = () => {
        if (!houveAlteracaoAcoes()){
            fecharELiberarLock();
            return;
        }

        confirmDialog({
            message: (
                <div>
                    Você tem alterações não salvas!<br />
                    Deseja realmente sair sem salvar?
                </div>
            ),
            header: 'Confirmação',
            icon: 'pi pi-exclamation-triangle',
            rejectLabel: 'NÃO',
            acceptLabel: 'SIM',
            accept: () => {
                fecharELiberarLock();
            }
        });
    }
    
    return (
        <Dialog closable={false} header={'Editar ações de melhoria'} footer={footer} visible={visible} style={{ width: '90vw' }} modal onHide={confirmarSaida} >
            <FormikFormTomadasAcoes
                id="edit-tomadasacoes"
                header={headerTomadasAcoes}
                dropdownOptions={{ avaliacao: DROPDOWN_OPTIONS_AVALIACAO }}
                handleSubmit={handleSalvarTopico}
                topico={editTopico}
                usuario={usuario.email}
                enviarAcoesAtualizadas={receberAcoesAtualizadas}
            />
        </Dialog>
    );
};

export default ModalEditarTomadasAcoes;